import { CustomerActionConfiguration } from 'src/app/services/dtos/customerActionConfiguration';
import { CustomerSearchForm } from 'src/app/services/dtos/customerSearchForm';
import { PluginFileSettingWithContent } from 'src/app/services/dtos/pluginFileSettingWithContent';
import { UserForm } from 'src/app/services/dtos/userForm';
import { CustomerForm } from '../../services/dtos/customerForm';
import { CustomerWithConfigurationsForm } from '../../services/dtos/customerWithConfigurationsForm';

export class FetchMessageTypesIfEmpty {
  public static readonly type = '[Customers] Fetch All Message Types if empty';
}

export class FetchCustomerPluginConfigurationIfEmpty {
  public static readonly type = '[Customers] Fetch Customer Plugin Configuration if empty';
  public constructor(public pluginId: string) { }
}

export class FetchCustomerActionConfiguration {
  public static readonly type = '[Customers] Fetch Customer Action Configuration';
  public constructor(public actionId: string) { }
}

export class FetchAllCustomersBasicInfo {
  public static readonly type = '[Customers] Fetch All Basic Infos';
  public constructor(public filters: CustomerSearchForm) {}
}

export class FetchCurrentUserAllCustomersBasicInfo {
  public static readonly type = '[Customers] Fetch Current Customer All Basic Infos';
}

export class FetchCustomer {
  public static readonly type = '[Customers] Fetch Single';
  public constructor(public id: string) { }
}

export class UpdateCustomer {
  public static readonly type = '[Customers] Update';
  public constructor(public payload: CustomerWithConfigurationsForm) { }
}

export class DeleteCustomerActionConfiguration {
  public static readonly type = '[Customers] Delete Customer Action Configuration';
  public constructor(public customerId: string, public actionId: string) { }
}

export class AddOrUpdateCustomerActionConfiguration {
  public static readonly type = '[Customers] Add Or Update Customer Action Configuration';
  public constructor(public payload: CustomerActionConfiguration) { }
}

export class DeleteCustomer {
  public static readonly type = '[Customers] Delete';
  public constructor(public id: string) { }
}

export class AddCustomer {
  public static readonly type = '[Customers] Add';
  public constructor(public payload: CustomerForm) { }
}

export class AddCustomerMapping {
  public static readonly type = '[Customer] Add mapping';
  public constructor(public payload: string) { }
}

export class ImportCustomer {
  public static readonly type = '[Customers] Import';
  // eslint-disable-next-line @typescript-eslint/ban-types
  public constructor(public payload: object) { }
}

export class SetCurrentCustomerId {
  public static readonly type = '[Customers] Set Current Customer Id';
  public constructor(public id: string) { }
}

export class ClearCurrentCustomerId {
  public static readonly type = '[Customers] Clear Current Customer Id';
}

export class SetSelectedMessageType {
  public static readonly type = '[Customers] Set Selected Message Type';
  public constructor(public messageType: string) { }
}

export class SetActivePluginId {
  public static readonly type = '[Customers] Set Active Plugin Id';
  public constructor(public pluginId: string) { }
}

export class UpdatePluginCustomerConfigurationFile {
  public static readonly type = '[Customers] Update Plugin Customer Configuration File';
  public constructor(public pluginId: string, public customerId: string, public payload: PluginFileSettingWithContent) {}
}

export class UpdateCustomerUser {
  public static readonly type = '[Customers] Update Customer User';
  public constructor(public payload: UserForm) { }
}

export class AddCustomerUser {
  public static readonly type = '[Customers] Add Customer User';
  public constructor(public customerId: string, public payload: UserForm) { }
}

export class DeleteCustomerUser {
  public static readonly type = '[Customers] Delete Customer User';
  public constructor(public customerId: string, public userId: string) { }
}

